import styled from "@emotion/styled";
import { IconContainerProps, Rating, RatingProps } from "@mui/material";
import { FC, useCallback } from "react";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import { styled as muiStyled } from "@mui/material/styles";
import { useField } from "formik";

const StyledRating = muiStyled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled
  }
}));

interface IRatingFieldProps extends RatingProps {
  name: string;
}

const RatingField: FC<IRatingFieldProps> = props => {
  const [field, meta, helpers] = useField({ name: props.name! });

  const handleChange = useCallback(
    (
      event: React.SyntheticEvent<Element, Event>,
      value: number | null
    ) => {
      helpers.setValue(value);
    },
    [helpers, props]
  );

  const config: RatingProps = {
    ...props,
    ...field,
    id: "id-rating" + props.name,
    onChange: handleChange,
    IconContainerComponent: IconContainer,
    getLabelText: (value: number) => customIcons[value].label,
    highlightSelectedOnly: true,
    max: 3
  };
  return <StyledRating {...config} />;
};

export default RatingField;

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <SentimentSatisfiedAltIcon color="success" fontSize="large" />,
    label: "Satisfecho"
  },
  2: {
    icon: <SentimentSatisfiedIcon color="warning" fontSize="large" />,
    label: "Neutral"
  },
  3: {
    icon: <SentimentVeryDissatisfiedIcon color="error" fontSize="large" />,
    label: "Insatisfecho"
  },
  4: {
    icon: <></>,
    label: ""
  },
  5: {
    icon: <></>,
    label: ""
  }
};

const Container = styled.div`
  width: auto;
`;

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return (
    <ContainerEmotions className="icon-s">
      <span {...other}>{customIcons[value].icon} </span>
      <CustomSpan {...other}>{customIcons[value].label} </CustomSpan>
    </ContainerEmotions>
  );
}

const CustomSpan = styled.span`
  font-size: 10px;
  color: black;
`;

const ContainerEmotions = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 75px;
`;
